export default __webpack_public_path__ + "images/d891400321362475afb2e17a5f561918.svg";